import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import logo from "../../assets/logo.svg";
import background from "../../assets/bg.jpg";
import backgroundIPhone from "../../assets/bg_iphone.jpg";
import eyeIconClosed from "../../assets/view_icon.svg";
import eyeIconOpened from "../../assets/view_icon_open.svg";
import { apiEndpoint } from "../../api/apiEndpoint";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext.component";
import { types } from "../../context/types";
import { getError } from "../../helpers/generateError";
import {
  canContinue,
  navigateToUserHome,
  bePendingErrors,
} from "./LoginPage.helper";
import { BRAND } from "../../environment";

export const LoginPage = () => {
  // Create state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Errors for inputs
  const [emailError, setEmailError] = useState();
  const [passwordError, setPasswordError] = useState();

  // Show/Hide Password
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(!passwordShown);
  };

  //Import context
  const { dispatch } = useContext(UserContext);

  // Navigate
  const navigate = useNavigate();
  useEffect(() => {
    navigateToUserHome(navigate);
  }, [navigate]);

  // Handle Submit to Login
  const handleSubmit = (e) => {
    e.preventDefault();
    sendRequest();
  };

  // Request to Login
  const sendRequest = async () => {
    try {
      const formData = new FormData();
      formData.append("username", email);
      formData.append("password", password);
      formData.append("client_id", `${process.env.REACT_APP_AUTH_CLIENT_ID}`);
      formData.append("grant_type", "password");

      const { data } = await apiEndpoint({
        method: "post",
        url: "/auth/oauth2/token/",
        data: formData,
        headers: {
          "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        },
      });
      navigate("/");
      sessionStorage.setItem("user", true);
      sessionStorage.setItem("token", data.access_token);
      sessionStorage.setItem("data", JSON.stringify(data));
      dispatch({
        type: types["[Login]"],
        payload: data,
      });
      setEmail("");
      setPassword("");
      //TODO: Redirect to plans page once user its authenticated
    } catch (err) {
      toast.error(err.response.data.error_description);
    }
  };

  useEffect(() => {
    bePendingErrors(password, setPasswordError, email, setEmailError);
  }, [email, password]);

  const errorBorderSyle = "border-red-600";

  const maybeEmailError = (callback) => {
    return emailError && callback();
  };
  const ifPasswordShown = (doTrue, doFalse) => {
    return passwordShown ? doTrue : doFalse;
  };
  return (
    <>
      <div className="hidden md:flex text-center use-normal font-sans text-lg">
        <nav
          className=" w-[333px] text-white h-[100vh] flex flex-col text-center items-center"
          style={{
            backgroundImage: `url(${background})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <img src={logo} alt="logo" className="h-[85px] mt-32" />
          <h2 className="font-semibold font-sm mt-12 text-[22px] w-[90%] text-center">
            Welcome to the next generation diagnosis
          </h2>
        </nav>
        <div className="flex justify-center flex-col items-left pl-[120px] w-[100%]">
          <h3 className="font-semibold text-left w-[50%] text-[17px] mb-9 text-primary-4">
            Sign in to {BRAND.NAME}
          </h3>
          <form className="flex flex-col w-[50%]" onSubmit={handleSubmit}>
            <div className="relative w-[333px]">
              <input
                name="email"
                value={email}
                autoComplete="off"
                onChange={({ target }) => setEmail(target.value)}
                type="text"
                data-testid="email-input"
                placeholder="Email"
                className={`peer cursor-white border border-grey focus:border-primary-1 outline-none py-2.5 pl-[17px]  caret-primary-1 rounded-[12px] placeholder-transparent text-[13px] h-[36px] w-[333px] ${maybeEmailError(
                  () => errorBorderSyle
                )}`}
              />
              <label
                htmlFor="email"
                className="pointer-text pointer-events-none absolute left-0 -top-7 text-[11px] font-semibold text-left ml-[17px] transition-all peer-autofill:-top-7 peer-autofill:text-[11px] peer-autofill:font-semibold peer-focus:-top-7 peer-focus:text-[11px] peer-focus:font-semibold peer-placeholder-shown:text-primary-4 peer-placeholder-shown:text-[13px] peer-placeholder-shown:font-normal peer-placeholder-shown:top-1 "
              >
                Email
              </label>
            </div>
            {maybeEmailError(() => (
              <small
                className="pl-[17px] text-left text-xs"
                data-testid="email-error"
              >
                {getError(emailError)}
              </small>
            ))}

            <div className="relative w-[333px]">
              <input
                data-testid="password-input"
                name="password"
                autoComplete="off"
                value={password}
                onChange={({ target }) => setPassword(target.value)}
                type={ifPasswordShown("text", "password")}
                placeholder="Password"
                className={`peer text-[13px]  block border border-grey focus:border-primary-1 outline-none caret-primary-1  pl-[17px] rounded-[12px] placeholder-transparent h-[36px] w-[333px] mt-8  ${
                  passwordError && errorBorderSyle
                }`}
              />
              <label
                htmlFor="password"
                className="pointer-text pointer-events-none absolute left-0 top-1 text-[11px] font-semibold text-left ml-[17px] transition-all peer-autofill:top-1 peer-autofill:text-[11px] peer-autofill:font-semibold peer-focus:top-1 peer-focus:text-[11px] peer-focus:font-semibold peer-placeholder-shown:text-primary-4 peer-placeholder-shown:text-[13px] peer-placeholder-shown:font-normal peer-placeholder-shown:top-9"
              >
                Password
              </label>
              <img
                src={ifPasswordShown(eyeIconOpened, eyeIconClosed)}
                alt="Eye Icon"
                className="absolute right-5 bottom-2 cursor-pointer"
                onClick={togglePasswordVisiblity}
                data-testid="eye-icon"
              />
            </div>
            {passwordError && (
              <small
                className="pl-[17px] text-left text-xs"
                data-testid="password-error"
              >
                {getError(passwordError)}
              </small>
            )}
            <button
              data-testid="login-button"
              disabled={!canContinue(email, password)}
              type="submit"
              className="border w-[171px] h-[36px] mt-7 text-white font-semibold text-base rounded-2xl bg-primary-1 active:bg-[#7DBEEA] disabled:bg-[#E5E5E5] disabled:text-[#727272] disabled:cursor-not-allowed"
            >
              Login
            </button>
          </form>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${backgroundIPhone})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="w-full h-[100vh] md:hidden"
      >
        <div className="flex flex-col items-center h-full justify-center">
          <img src={logo} className="w-[69px] h-[92px]" alt="logo" />
          <h3 className="text-xl text-white mt-6 font-semibold">Login</h3>
          <form
            className="flex flex-col w-full items-center"
            onSubmit={handleSubmit}
          >
            <label
              htmlFor="name"
              className="text-sm text-left w-[80%] font-semibold text-white mt-5"
            >
              Email
            </label>
            <input
              autoComplete="off"
              value={email}
              onChange={({ target }) => setEmail(target.value)}
              id="name"
              type="text"
              className={`rounded-[12px] mt-3 p-3 w-[90%] placeholder-[#338CC7] caret-primary-1 text-sm outline-none ${maybeEmailError(
                () => errorBorderSyle
              )}`}
              placeholder="Enter email"
            />
            {maybeEmailError(() => (
              <small className="text-left text-xs block w-[90%] p-3">
                {getError(emailError)}
              </small>
            ))}
            <label
              htmlFor="password"
              className="text-sm text-left font-semibold w-[80%] text-white mt-4"
            >
              Password
            </label>
            <div className="relative w-[90%]">
              <input
                autoComplete="off"
                id="password"
                value={password}
                onChange={({ target }) => setPassword(target.value)}
                type={passwordShown ? "text" : "password"}
                className={`rounded-[12px] text-sm mt-3 p-3 w-[100%] placeholder-[#338CC7] caret-primary-1 outline-none ${
                  passwordError && errorBorderSyle
                }`}
                placeholder="Enter password"
              />
              <img
                src={passwordShown ? eyeIconOpened : eyeIconClosed}
                alt="Eye Icon"
                className="absolute right-5 bottom-3 cursor-pointer"
                onClick={togglePasswordVisiblity}
              />
            </div>
            {passwordError && (
              <small className="text-left text-xs block w-[90%] p-3">
                {getError(passwordError)}
              </small>
            )}
            <p className="text-white mt-5 text-base w-[90%] text-right underline">
              Forgot password
            </p>

            <button
              disabled={!canContinue(email, password)}
              type="submit"
              className="text-base mt-8 rounded-[12px] text-white w-[90%] text-center py-3 bg-[#338CC7] active:bg-[#7DBEEA] disabled:bg-[#E5E5E5] disabled:text-[#727272] disabled:cursor-not-allowed"
            >
              Login
            </button>
          </form>
          <p className="text-base text-white mt-12">Do you have any doubt?</p>
          <p className="text-base text-white mt-1 underline">Contact Us</p>
        </div>
      </div>
    </>
  );
};
